import { ICON__brush_clean } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { HOOK_IMAGE__get_image_mask_for } from '@/utils/_methods/FN_IMAGE__get_image_mask_for';
import { FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph } from '@/utils/_methods/FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph';
import { create_single_color_image } from '@/utils/UTILS__image';
import { assert_true } from '@shared/asserts/utils_asserts';
import { ENUM__color } from '@shared/dto/+image/_enums/ENUM__color';

export function G_BUTTON__image_edit__mask_clear() {
  /*
   * STORE
   */
  const { g_image_edit__field, g_general__ui_disabled } = use_slice_ui(['g_image_edit__field', 'g_general__ui_disabled']);
  const field = g_image_edit__field;

  const field_mask = HOOK_IMAGE__get_image_mask_for(field);

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    assert_true(field_mask.image__is_initialized);
    assert_true(field_mask.is_category_mask);

    let image_size = field_mask.get_image_size();

    let file_data = await create_single_color_image(ENUM__color.WHITE, image_size);

    await FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph(file_data, field_mask);
  }

  function is_disabled() {
    return g_general__ui_disabled || field_mask.asset.is_single_color_mask_empty || !field_mask.is_category_mask;
  }

  /*
   * FUNCTIONS
   */

  /*
   * HTML
   */

  if (field_mask.is_stub()) return <PLACEHOLDER_bar_line />;
  if (!field_mask.image__is_initialized) return <PLACEHOLDER_bar_line />;

  assert_true(field_mask.is_category_mask);

  return (
    <UI_PRIMITIVE__button disabled={is_disabled()} variant={'outline-on-bar'} size={'w-full-h-10'} {...{ onClick }}>
      <ICON__brush_clean className="!size-3 text-bar-foreground" />
      Clear Mask
    </UI_PRIMITIVE__button>
  );
}
